import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as HomeSvg } from './assets/home.svg';

const HomeIcon = React.forwardRef((args, ref) => <SvgIcon component={HomeSvg} ref={ref} {...args} />);

export default HomeIcon;
